<template>
  <v-sheet class="d-flex flex-column justify-center align-center mx-12 mb-12" color="secondary" height="600px">
    <span class="display-4 font-weight-bold primary--text">404</span>
    <span class="display-1 mt-6">找不到路徑</span>
    <span class="subtitle-1 accent--text mt-2">*請檢查路徑是否有誤</span>
  </v-sheet>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style></style>
